import React, { useState, useEffect } from "react";
import { useShadowTechnique } from "../../context/ShadowTechniqueContext";
import ShadowTechniqueHelp from "./ShadowTechniqueHelp";
import "./ShadowTechniqueSettings.css";

const ShadowTechniqueSettings = ({ onClose }) => {
  const {
    showProcessBox,
    setShowProcessBox,
    repeatCount,
    setRepeatCount,
    repeatSettings,
    initializeRepeatSettings,
    updateRepeatSetting,
  } = useShadowTechnique();

  const [selectedRepeat, setSelectedRepeat] = useState(0);
  const [showRepeatSelector, setShowRepeatSelector] = useState(false);
  const [showHelp, setShowHelp] = useState(false);

  // مقداردهی اولیه تنظیمات
  useEffect(() => {
    if (repeatSettings.length === 0) {
      initializeRepeatSettings(repeatCount);
    }
  }, [repeatCount, initializeRepeatSettings, repeatSettings.length]);

  const handleRepeatCountChange = (count) => {
    setRepeatCount(count);
    initializeRepeatSettings(count);
    setSelectedRepeat(0);
    setShowRepeatSelector(false);
  };

  // تابع محاسبه درصد برای نمایش پیشرفت (سمت راست حداقل، سمت چپ حداکثر)
  const calculateProgress = (value, min, max) => {
    return ((value - min) / (max - min)) * 100;
  };

  return (
    <>
      <div className="settings-overlay" onClick={onClose}>
        <div
          className="settings-panel shadow-settings-panel"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="settings-header">
            <div className="settings-title">
              <h3>⚙️ تکنیک سایه</h3>
              <button
                className="help-button"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowHelp(true);
                }}
                title="راهنما"
              >
                ❓
              </button>
            </div>
            <button className="settings-close" onClick={onClose}>
              <i className="fas fa-times"></i>
            </button>
          </div>

          <div className="settings-content">
            {/* ردیف اول: نمایش کادر + تعداد تکرار */}
            <div className="settings-row">
              <div className="setting-card">
                <div className="setting-card-content">
                  <span className="setting-label">📦 کادر فرآیند</span>
                  <label className="toggle-switch">
                    <input
                      type="checkbox"
                      checked={showProcessBox}
                      onChange={(e) => setShowProcessBox(e.target.checked)}
                    />
                    <span className="toggle-slider"></span>
                  </label>
                </div>
              </div>

              <div className="setting-card repeat-selector-container">
                <div
                  className="repeat-selector"
                  onClick={() => setShowRepeatSelector(!showRepeatSelector)}
                >
                  <span>🔁 {repeatCount} بار</span>
                  <span className="dropdown-arrow">▼</span>
                </div>

                {showRepeatSelector && (
                  <div className="repeat-dropdown">
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                      <button
                        key={num}
                        className={`repeat-option ${
                          repeatCount === num ? "active" : ""
                        }`}
                        onClick={() => handleRepeatCountChange(num)}
                      >
                        {num}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>

            {/* تب‌های انتخاب تکرار */}
            <div className="repeat-tabs">
              {repeatSettings.map((_, index) => (
                <button
                  key={index}
                  className={`repeat-tab ${
                    selectedRepeat === index ? "active" : ""
                  }`}
                  onClick={() => setSelectedRepeat(index)}
                  title={`تنظیمات تکرار ${index + 1}`}
                >
                  {index + 1}
                </button>
              ))}
            </div>

            {/* تنظیمات تکرار انتخاب شده */}
            {repeatSettings[selectedRepeat] && (
              <div className="repeat-settings-card">
                <div className="repeat-title">
                  ⚙️ تنظیمات تکرار {selectedRepeat + 1} از {repeatCount}
                </div>

                {/* ولوم */}
                <div className="setting-item">
                  <div className="setting-header">
                    <span className="setting-icon">🔊</span>
                    <span className="setting-name">صدا</span>
                    <span className="setting-value">
                      {Math.round(repeatSettings[selectedRepeat].volume * 100)}%
                    </span>
                  </div>
                  <input
                    type="range"
                    min="0"
                    max="1"
                    step="0.01"
                    value={repeatSettings[selectedRepeat].volume}
                    onChange={(e) =>
                      updateRepeatSetting(
                        selectedRepeat,
                        "volume",
                        parseFloat(e.target.value),
                      )
                    }
                    className="volume-slider-shadow"
                    style={{
                      background: `linear-gradient(90deg, 
        #3a3a3a 0%, 
        #3a3a3a ${100 - repeatSettings[selectedRepeat].volume * 100}%, 
        #667eea ${100 - repeatSettings[selectedRepeat].volume * 100}%, 
        #764ba2 100%)`,
                    }}
                  />
                  <div className="volume-labels">
                    <span>۰%</span>
                    <span>۵۰%</span>
                    <span>۱۰۰%</span>
                  </div>
                </div>

                {/* سرعت */}
                <div className="setting-item">
                  <div className="setting-header">
                    <span className="setting-icon">⏱️</span>
                    <span className="setting-name">سرعت</span>
                    <span className="setting-value">
                      {repeatSettings[selectedRepeat].speed.toFixed(2)}x
                    </span>
                  </div>
                  <input
                    type="range"
                    min="0.2"
                    max="3"
                    step="0.05"
                    value={repeatSettings[selectedRepeat].speed}
                    onChange={(e) =>
                      updateRepeatSetting(
                        selectedRepeat,
                        "speed",
                        parseFloat(e.target.value),
                      )
                    }
                    className="speed-slider"
                    style={{
                      background: `linear-gradient(90deg, 
        #3a3a3a 0%, 
        #3a3a3a ${
          100 - ((repeatSettings[selectedRepeat].speed - 0.2) / 2.8) * 100
        }%, 
        #667eea ${
          100 - ((repeatSettings[selectedRepeat].speed - 0.2) / 2.8) * 100
        }%, 
        #764ba2 100%)`,
                    }}
                  />
                  <div
                    className="speed-labels"
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "15px",
                      marginTop: "5px",
                    }}
                  >
                    {/* 0.2x - سمت راست */}
                    <span
                      style={{
                        position: "absolute",
                        right: "0",
                        fontSize: "8px",
                        color: "#888",
                      }}
                    >
                      ۰٫۲x
                    </span>

                    {/* 1x - موقعیت دقیق: 28.57% از راست */}
                    <span
                      style={{
                        position: "absolute",
                        right: "30%",
                        transform: "translateX(50%)",
                        fontSize: "8px",
                        color: "#888",
                      }}
                    >
                      ۱x
                    </span>

                    {/* 2x - موقعیت دقیق: 64.28% از راست */}
                    <span
                      style={{
                        position: "absolute",
                        right: "64.28%",
                        transform: "translateX(50%)",
                        fontSize: "8px",
                        color: "#888",
                      }}
                    >
                      ۲x
                    </span>

                    {/* 3x - سمت چپ */}
                    <span
                      style={{
                        position: "absolute",
                        left: "0",
                        fontSize: "8px",
                        color: "#888",
                      }}
                    >
                      ۳x
                    </span>
                  </div>
                </div>

                {/* وضعیت زیرنویس */}
                <div className="setting-item">
                  <div className="setting-header">
                    <span className="setting-icon">📝</span>
                    <span className="setting-name">زیرنویس</span>
                  </div>
                  <div className="subtitle-buttons">
                    <button
                      className={`subtitle-button ${
                        repeatSettings[selectedRepeat].subtitleMode === "show"
                          ? "active"
                          : ""
                      }`}
                      onClick={() =>
                        updateRepeatSetting(
                          selectedRepeat,
                          "subtitleMode",
                          "show",
                        )
                      }
                      title="نمایش زیرنویس"
                    >
                      👁️
                    </button>
                    <button
                      className={`subtitle-button ${
                        repeatSettings[selectedRepeat].subtitleMode === "hidden"
                          ? "active"
                          : ""
                      }`}
                      onClick={() =>
                        updateRepeatSetting(
                          selectedRepeat,
                          "subtitleMode",
                          "hidden",
                        )
                      }
                      title="پنهان کردن زیرنویس"
                    >
                      🙈
                    </button>
                    <button
                      className={`subtitle-button ${
                        repeatSettings[selectedRepeat].subtitleMode ===
                        "undercover"
                          ? "active"
                          : ""
                      }`}
                      onClick={() =>
                        updateRepeatSetting(
                          selectedRepeat,
                          "subtitleMode",
                          "undercover",
                        )
                      }
                      title="زیر کاور (نمایش با هاور)"
                    >
                      🕵️
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* دکمه تایید */}
            <button className="save-settings-btn" onClick={onClose}>
              تایید و ذخیره تنظیمات
            </button>
          </div>
        </div>
      </div>

      {/* باکس راهنمای جداگانه */}
      {showHelp && <ShadowTechniqueHelp onClose={() => setShowHelp(false)} />}
    </>
  );
};

export default ShadowTechniqueSettings;
